import React from "react";
import * as jose from 'jose';
import { createRoot } from "react-dom/client";
import { JWTPayload } from "jose";
import { trackGaEvent } from "../../../util/gtm";
import voresConfiguration from "../../../client-configuration";
import { Cookie, CookieKeys } from "../../../util/cookie";
import { ConfirmSubscriptionModal } from "../../../components/email-subscription/confirm-subscription-modal";

const loadModal = (name: string, email: string) => {
  const container = document.createElement("div");
  container.id = "onetap-subscribe-modal";

  const root = createRoot(container);

  const onDecision = (confirmed: boolean) => {
    trackGaEvent("on_one_tap", {
      action: confirmed ? "confirm_subscription" : "deny_subscription"
    });

    root.unmount();

    Cookie.set(CookieKeys.SuppressSlideUp, "true", { expires: 3 });
  }

  root.render(<ConfirmSubscriptionModal name={name} email={email} onDecision={onDecision} />);

  document.body.appendChild(container);

  trackGaEvent("on_one_tap", {
    action: "show_confirm_modal"
  });
}

export const loadOneTap = () => {
  const scriptSrc = "https://accounts.google.com/gsi/client";

  const scriptElement = document.createElement("script");
  scriptElement.defer = true;
  scriptElement.async = true;

  const handleCredentialResponse = (e) => {
    const data = jose.decodeJwt(e.credential) as JWTPayload & { given_name: string; email: string };
    loadModal(data.given_name, data.email);

  }

  scriptElement.onload = () => {
    window.google?.accounts?.id?.initialize({
      client_id: voresConfiguration.googleSignInClientId,
      callback: handleCredentialResponse,
      context: "use",
        cancel_on_tap_outside: false,
        use_fedcm_for_prompt: true
    });
    window.google?.accounts?.id?.prompt((moment) => {
      console.log(moment);
    });

    trackGaEvent("on_one_tap", {
      action: "prompt"
    });
  }

  scriptElement.src = scriptSrc;
  document.body.appendChild(scriptElement);
}



